<template>
    <div class="billing-reports siot-table-wrapper">
        <div class="bookmarks">
            <div :class="['bookmark', activeBookmark == 1 ? 'active' : '']" @click="switchBookmark(1)">Generate</div>
            <div :class="['bookmark', activeBookmark == 2 ? 'active' : '']" @click="switchBookmark(2)">Reports</div>
        </div>
        <div v-if="activeBookmark == 1" class="bookmark-content generate-bookmark">
            <div class="reports-settings-box">
                <div class="carriers-box">
                    <h3>Select carrier</h3>
                    <div :class="['carrier-option', carrierId == 1 ? 'selected' : '']">
                        <input type="radio" name="carrier" id="simon-carrier" v-model="carrierId" value="1" @change="changeCarrier()">
                        <label for="simon-carrier">
                            <img src="../../assets/img/lightlogo.svg" alt="" class="light-mode">
                            <img src="../../assets/img/simon-carrier-dark.svg" alt="" class="dark-mode">
                        </label>
                    </div>
                    <div :class="['carrier-option', carrierId == 2 ? 'selected' : '']">
                        <input type="radio" name="carrier" id="t-mobile-carrier" v-model="carrierId" value="2" @change="changeCarrier()">
                        <label for="t-mobile-carrier">
                            <img src="../../assets/img/t-mobile-carrier.svg" alt="" class="light-mode">
                            <img src="../../assets/img/tmobile-carrier-dark.svg" alt="" class="dark-mode">
                        </label>
                    </div>
                    <div :class="['carrier-option', carrierId == 3 ? 'selected' : '']">
                        <input type="radio" name="carrier" id="vodafone-carrier" v-model="carrierId" value="3" @change="changeCarrier()">
                        <label for="vodafone-carrier">
                            <img src="../../assets/img/vodafone-logo.svg" alt="" class="light-mode">
                            <img src="../../assets/img/vodafone-logo.svg" alt="" class="dark-mode">
                        </label>
                    </div>
                    <div :class="['carrier-option', carrierId == 4 ? 'selected' : '']">
                        <input type="radio" name="carrier" id="kore-carrier" v-model="carrierId" value="4" @change="changeCarrier()">
                        <label for="kore-carrier">
                            <img src="../../assets/img/kore-logo.svg" alt="" class="light-mode">
                            <img src="../../assets/img/kore-logo.svg" alt="" class="dark-mode">
                        </label>
                    </div>
                </div>
                <div v-if="reportType != 'WALLET_STATE'" class="periods-box">
                    <h3>Select Billing Period</h3>
                    <select v-model="selectedCycle" class="custom-select form-control billing-cycle-select" @change="changePeriod()">
                        <option v-for="cycle in cycles" :key="cycle.offset" :value="cycle.offset">{{cycle.description}}</option>
                    </select>
                </div>
                <div v-else class="periods-box">
                    <div class="date-box">
                        <label for="startDate">Start date</label>
                        <date-picker v-model="startDate" id="startDate" valueType="format" :lang="langDataPicker" :first-day-of-week="1"></date-picker>
                        <span v-if="dateError != ''" class="error-msg">{{dateError}}</span>
                    </div>
                    <div class="date-box">
                        <label for="endDate">End date</label>
                        <date-picker v-model="endDate" id="endDate" valueType="format" :lang="langDataPicker" :first-day-of-week="1"></date-picker>
                    </div>
                </div>
                <div v-if="carrierId == 1 && (reportType == 'COST_DISTRIBUTION' || reportType == 'BILLING_DISCREPANCY')" class="genesis-file-box">
                    <h3>Genesis Statement File</h3>
                    <div class="genesis-file-upload">
                        <label for="genesis-file-upload" class="btn btn-primary upload-genesis-file-input">
                            <span>Upload</span>
                            <input id="genesis-file-upload" type="file" @change="readGenesisFile($event)"/>
                        </label>
                        <div v-if="genesisFileUploaded" class="invoice-status">
                            <i class="fa fa-check"></i>
                            <span class="invoice-status-text">Genesis Statement File uploaded</span>
                        </div>
                        <div v-else class="invoice-status">
                            <i class="fa fa-close"></i>
                            <span class="invoice-status-text">Genesis Statement File missing</span>
                        </div>
                    </div>
                </div>
                <div v-if="carrierId == 2" class="bans-box">
                    <h3>BAN invoices</h3>
                    <h3>BAN ID</h3>
                    <div class="bans-list">
                        <div v-for="ban of bans" class="ban">
                            <span class="ban-id">{{ban.ban}}</span>
                            <label :for="'ban-upload-' + ban.ban" class="btn btn-primary upload-ban-input">
                                <span v-if="ban.uploaded">Re-upload</span>
                                <span v-else>Upload</span>
                                <input :id="'ban-upload-' + ban.ban" type="file" @change="readInvoice(ban.ban, ban.uploaded, $event)"/>
                            </label>
                            <div v-if="ban.uploaded" class="invoice-status">
                                <i class="fa fa-check"></i>
                                <span class="invoice-status-text">Invoice uploaded</span>
                            </div>
                            <div v-else class="invoice-status">
                                <i class="fa fa-close"></i>
                                <span class="invoice-status-text">Invoice missing</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="billing-reports-control">
                <div class="radio-box">
                    <input type="radio" id="detailedReport" name="company-access" v-model="reportType" value="DETAILED">
                    <label for="detailedReport"><span>Detailed report</span></label>
                </div>
                <div class="radio-box">
                    <input type="radio" id="generalReport" name="company-access" v-model="reportType" value="GENERAL">
                    <label for="generalReport"><span>General report</span></label>
                </div>
                <div v-if="carrierId == 1" class="radio-box">
                    <input type="radio" id="costDistributionReport" name="company-access" v-model="reportType" value="COST_DISTRIBUTION">
                    <label for="costDistributionReport"><span>Cost Distribution</span></label>
                </div>
                <div v-if="carrierId == 1" class="radio-box">
                    <input type="radio" id="billingDiscrepancyReport" name="company-access" v-model="reportType" value="BILLING_DISCREPANCY">
                    <label for="billingDiscrepancyReport"><span>Billing Discrepancy</span></label>
                </div>
                <div v-if="carrierId == 1" class="radio-box">
                    <input type="radio" id="walletReport" name="company-access" v-model="reportType" value="WALLET_STATE">
                    <label for="walletReport"><span>Wallet Report</span></label>
                </div>
                <button class="btn btn-primary" :disabled="carrierId == 2 && (bans[0].uploaded == false || bans[1].uploaded == false || bans[2].uploaded == false)" @click="generateReport()">Generate</button>
            </div>
        </div>
        <div v-if="activeBookmark == 2" class="bookmark-content reports">
            <div class="siot-table-header">
                <div class="siot-table-header-left">
                    <div class="siot-table-search">
                        <div class="siot-table-search-field">
                            <input type="text" id="transactionsSearch" v-model="filter" v-on:keyup="searchKeyUp" v-on:keydown="searchKeyDown" placeholder="Search" />
                            <img class="light-mode" src="../../assets/img/Clear-field.svg" @click="clearSearch()" alt="">
                            <img class="dark-mode" src="../../assets/img/Clear-field-darkmode.svg" @click="clearSearch()" alt="">
                        </div>
                    </div>
                </div>

                <div class="siot-table-header-right">
                    <div class="siot-table-size">
                        <label for="size-page">Display:</label>
                        <select id="size-page" v-model="sortSettings.size" @change="getReportsList(true)" class="form-control custom-select">
                            <option value="40" selected>40</option>
                            <option value="60">60</option>
                            <option value="80">80</option>
                            <option value="100">100</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="siot-table-content">
                <div class="siot-table table-reports">
                    <table class="table b-table table-striped table-hover b-table-selectable b-table-select-multi">
                        <thead role="rowgroup">
                        <tr role="row">
                            <th @click="changeSort(1)" :aria-sort="setAreaSort(1)">ID</th>
                            <th @click="changeSort(4)" :aria-sort="setAreaSort(4)">Report Type</th>
                            <th @click="changeSort(2)" :aria-sort="setAreaSort(2)">Carrier</th>
                            <th @click="changeSort(3)" :aria-sort="setAreaSort(3)">Billing period</th>
                            <th @click="changeSort(5)" :aria-sort="setAreaSort(5)">Generation request timestamp</th>
                            <th @click="changeSort(6)" :aria-sort="setAreaSort(6)">Ordered by</th>
                            <th @click="changeSort(7)" :aria-sort="setAreaSort(7)">Completed at</th>
                            <th class="download-th">Download</th>
                        </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(report, index) in reportsList" v-bind:key="index">
                                <td>{{report.reportId}}</td>
                                <td>{{report.reportType.displayName}}</td>
                                <td>
                                    <span v-if="report.carrierId == 1">Simon IoT</span>
                                    <span v-else-if="report.carrierId == 2">T-Mobile</span>
                                    <span v-else-if="report.carrierId == 3">Vodafone</span>
                                    <span v-else-if="report.carrierId == 4">Kore</span>
                                    <span v-else>N/A</span>
                                </td>
                                <td>{{report.billingPeriod}}</td>
                                <td>{{report.orderedAt}}</td>
                                <td>{{report.orderedBy}}</td>
                                <td>{{report.completedAt}}</td>
                                <td v-if="report.finished" class="download-td">
                                    <button v-on:click="downloadReport(report.reportId, report.reportType.displayName)" class="btn download">Download</button>
                                </td>
                                <td v-else class="download-td">
                                    <span class="generating">Generating ...</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="siot-table-footer">
                <div class="siot-table-footer-center">
                    <nav v-if="paginationCount" aria-label="Page navigation example">
                        <paginate :page-count="paginationCount" v-model="sortSettings.page" :click-handler="paginationControll" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination justify-content-center'" :page-class="'page-item'" :page-link-class="'page-link'" :prev-class="'page-item'" :prev-link-class="'page-link'" :next-class="'page-item'" :next-link-class="'page-link'"></paginate>
                    </nav>
                </div>
            </div>
        </div>
        <div class="loading" v-if="loadingReports">
            <div class="loading-inner">
                <div class="sk-wave">
                    <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                </div>

                <div class="text">
                    Getting reports list..
                </div>
            </div>
        </div>
        <b-modal size="md" ref="fileFormatModal" id="fileFormatModal" centered hide-footer>
            <div class="file-format-popup">
                <img src="../../assets/img/file-format.svg">
                <h3>Save report file as:</h3>
                <div>
                    <button class="btn btn-primary csv" v-on:click="generateCsv">CSV</button>
                    <button class="btn btn-primary xls" v-on:click="generateXlsx">XLSX</button>
                </div>
                <button class="btn btn-light" @click="hidefileFormatPopup()">Cancel</button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import Axios from "axios";
    import globalStore from "../../variables";
    import Paginate from 'vuejs-paginate';
    import DatePicker from 'vue2-datepicker'

    export default {
        name: "BillingReports",
        components: {
            Paginate,
            DatePicker
        },
        data() {
            return {
                activeBookmark: 1,
                reportType: 'DETAILED',
                carrierId: 1,
                cycles: [],
                selectedCycle: 0,
                genesisFileUploaded: false,
                bans: [
                    {ban: '', uploaded: false},
                    {ban: '', uploaded: false},
                    {ban: '', uploaded: false}
                    ],
                loadingGenerating: false,
                loadingReports: false,
                sortSettings: {
                    page: 1,
                    desc: true,
                    size: 40,
                    sort: 1
                },
                paginationCount: 1,
                filter: '',
                searchString: '',
                reportsList: [],
                reportsNotReady: [],
                reportSelected: null,
                reportSelectedType: null,
                timeout: null,
                langDataPicker: {
                    days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                    pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
                    placeholder: {
                        date: 'Select Date',
                        dateRange: 'Select Date Range'
                    }
                },
                startDate: null,
                endDate: null,
                dateError: ''
            }
        },
        methods: {
            changeCarrier() {
                this.getBillingCycles()
                if (this.carrierId != 1 && (this.reportType == 'COST_DISTRIBUTION' || this.reportType == 'BILLING_DISCREPANCY' || this.reportType == 'WALLET_STATE')) {
                    this.reportType = 'DETAILED'
                }
                if (this.carrierId == 2) {
                    this.getStatements();
                }
            },
            changePeriod() {
                if (this.carrierId == 1) {
                    this.checkStatementFile()
                } else if (this.carrierId == 2) {
                    this.getStatements();
                }
            },
            getBillingCycles() {
                this.selectedCycle = 0;
                Axios.get( globalStore.data.restApiUrl + '/billing-ng/cycles?carrierId=' + this.carrierId)
                    .then (response => {
                        this.cycles = response.data
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Error occured during getting billing cycles.',
                            text: 'Something wen wrong during getting data of billing cycles. Please, contact support.',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            },
            generateReport() {
                //DETAILED, COST_DISTRIBUTION, BILLING_DISCREPANCY, GENERAL
                let parsedData = {}
                if (this.reportType != 'WALLET_STATE') {
                    parsedData = {
                        carrierId: this.carrierId,
                        reportType: this.reportType,
                        offset: this.selectedCycle
                    }
                } else {
                    parsedData = {
                        carrierId: this.carrierId,
                        reportType: this.reportType
                    }

                    let today = new Date()
                    today = today.getFullYear() + '-' + ("0" + (today.getMonth() + 1)).slice(-2) + '-' + ("0" + today.getDate()).slice(-2);

                    if (this.startDate == '' || this.endDate == '') {
                        this.dateError = 'Both dates must be selected'
                        return false
                    } else if (this.startDate > this.endDate) {
                        this.dateError = 'Start date must be earlier than end date'
                        return false
                    } else if ((this.startDate > today) || (this.endDate > today)) {
                        this.dateError = 'Dates can not be from the future'
                        return false
                    } else {
                        this.dateError = ''
                    }

                    let startDate = new Date(this.startDate),
                        endDate = new Date(this.endDate);

                    parsedData.startDate = startDate.getFullYear() + '-' + ("0" + (startDate.getMonth() + 1)).slice(-
                        2) + '-' + ("0" + startDate.getDate()).slice(-2) + ' 00:00:00';
                    parsedData.endDate = endDate.getFullYear() + '-' + ("0" + (endDate.getMonth() + 1)).slice(-2) +
                        '-' + ("0" + endDate.getDate()).slice(-2) + ' 00:00:00';
                }
                Axios.post(globalStore.data.restApiUrl + '/reporting/billing', parsedData)
                    .then(response => {
                        this.$notify({
                            type: 'success',
                            group: 'notification',
                            title: 'Your report is generating.',
                            text: 'It will be available at reports bookmark soon.',
                            duration: 5000,
                        });
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Error occured during generating report.',
                            text: 'Something went wrong during generating report. Please, contact support.',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            },
            readGenesisFile(ev) {
                if (ev.target) {
                    var f = ev.target.files[0];
                } else {
                    var f = ev[0];
                }

                var ext = f.name.slice(f.name.lastIndexOf("."));

                if (ext === ".csv") {
                    let formData = new FormData();
                    formData.append('file', ev.target.files[0]);
                    Axios.post(`${globalStore.data.restApiUrl}/reporting/billing/parse?offset=${this.selectedCycle}`, formData, {headers: {'Content-Type': 'multipart/form-data'}})
                        .then(response => {
                            this.checkStatementFile();
                            this.$notify({
                                type: 'success',
                                group: 'notification',
                                title: 'Genesis Statement File uploaded successfully',
                                text: 'Your Genesis Statement File has been updated succesfully and will be parsed by server soon.',
                                duration: 5000,
                            });

                        })
                        .catch(error => {
                            console.log(error)
                            if (error.response.status == 400) {
                                if (error.response.data.errors[0].errorCode == 'BadApiRequestException' && error.response.data.errors[0].errorMessage == 'Passed file seems to be incorrect for selected ban.') {
                                    this.$notify({
                                        type: 'error',
                                        group: 'notification',
                                        title: 'Replace error',
                                        text: 'Passed file seems to be incorrect for selected ban.',
                                        duration: 5000,
                                    });
                                } else if (error.response.data.errors[0].errorCode == 'BadApiRequestException' && error.response.data.errors[0].errorMessage == 'Passed file is not csv.') {
                                    this.$notify({
                                        type: 'error',
                                        group: 'notification',
                                        title: 'Replace error',
                                        text: 'Passed file is not csv.',
                                        duration: 5000,
                                    });
                                } else {
                                    this.$notify({
                                        type: 'error',
                                        group: 'notification',
                                        title: 'Replace error',
                                        text: 'An error has occured during replacing invoice.',
                                        duration: 5000,
                                    });
                                }
                            } else {
                                this.$notify({
                                    type: 'error',
                                    group: 'notification',
                                    title: 'Replace error',
                                    text: 'An error has occured during replacing invoice.',
                                    duration: 5000,
                                });
                            }
                        })
                } else {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Wrong file format',
                        text: 'Only .csv files are correct format of the invoice.',
                        duration: 5000,
                    });
                }
            },
            readInvoice(id, isReplace, ev) {
                if (ev.target) {
                    var f = ev.target.files[0];
                } else {
                    var f = ev[0];
                }

                var ext = f.name.slice(f.name.lastIndexOf("."));

                if (ext === ".csv") {
                    let formData = new FormData();
                    formData.append('file', ev.target.files[0]);
                    if (isReplace) {
                        Axios.post(`${globalStore.data.restApiUrl}/reporting/billing/magenta/parse/replace?ban=${id}&offset=${this.selectedCycle}`, formData, {headers: {'Content-Type': 'multipart/form-data'}})
                            .then(response => {
                                this.getStatements();
                                this.$notify({
                                    type: 'success',
                                    group: 'notification',
                                    title: 'Invoice replaced successfully',
                                    text: 'Your invoice has been updated succesfully and will be parsed by server soon.',
                                    duration: 5000,
                                });

                            })
                            .catch(error => {
                                console.log(error)
                                if (error.response.status == 400) {
                                    if (error.response.data.errors[0].errorCode == 'BadApiRequestException' && error.response.data.errors[0].errorMessage == 'Passed file seems to be incorrect for selected ban.') {
                                        this.$notify({
                                            type: 'error',
                                            group: 'notification',
                                            title: 'Replace error',
                                            text: 'Passed file seems to be incorrect for selected ban.',
                                            duration: 5000,
                                        });
                                    } else if (error.response.data.errors[0].errorCode == 'BadApiRequestException' && error.response.data.errors[0].errorMessage == 'Passed file is not csv.') {
                                        this.$notify({
                                            type: 'error',
                                            group: 'notification',
                                            title: 'Replace error',
                                            text: 'Passed file is not csv.',
                                            duration: 5000,
                                        });
                                    } else {
                                        this.$notify({
                                            type: 'error',
                                            group: 'notification',
                                            title: 'Replace error',
                                            text: 'An error has occured during replacing invoice.',
                                            duration: 5000,
                                        });
                                    }
                                } else {
                                    this.$notify({
                                        type: 'error',
                                        group: 'notification',
                                        title: 'Replace error',
                                        text: 'An error has occured during replacing invoice.',
                                        duration: 5000,
                                    });
                                }
                            })
                    } else {
                        Axios.post(`${globalStore.data.restApiUrl}/reporting/billing/magenta/parse?ban=${id}&offset=${this.selectedCycle}`, formData, {headers: {'Content-Type': 'multipart/form-data'}})
                            .then(response => {
                                this.getStatements();
                                this.$notify({
                                    type: 'success',
                                    group: 'notification',
                                    title: 'Upload success',
                                    text: 'Your invoice has been updated succesfully and will be parsed by server soon.',
                                    duration: 5000,
                                });

                            })
                            .catch(error => {
                                if (error.response.status == 400) {
                                    if (error.response.data.errors[0].errorCode == 'BadApiRequestException' && error.response.data.errors[0].errorMessage == 'Passed file seems to be incorrect for selected ban.') {
                                        this.$notify({
                                            type: 'error',
                                            group: 'notification',
                                            title: 'Upload error',
                                            text: 'Passed file seems to be incorrect for selected ban.',
                                            duration: 5000,
                                        });
                                    } else if (error.response.data.errors[0].errorCode == 'BadApiRequestException' && error.response.data.errors[0].errorMessage == 'Passed file is not csv.') {
                                        this.$notify({
                                            type: 'error',
                                            group: 'notification',
                                            title: 'Upload error',
                                            text: 'Passed file is not csv.',
                                            duration: 5000,
                                        });
                                    } else {
                                        this.$notify({
                                            type: 'error',
                                            group: 'notification',
                                            title: 'Upload error',
                                            text: 'An error has occured during uploading invoice.',
                                            duration: 5000,
                                        });
                                    }
                                } else {
                                    this.$notify({
                                        type: 'error',
                                        group: 'notification',
                                        title: 'Upload error',
                                        text: 'An error has occured during uploading invoice.',
                                        duration: 5000,
                                    });
                                }
                            })
                    }
                } else {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Wrong file format',
                        text: 'Only .csv files are correct format of the invoice.',
                        duration: 5000,
                    });
                }
            },
            getStatements() {
                Axios.get(globalStore.data.restApiUrl + '/reporting/billing/magenta/statement?offset=' + this.selectedCycle)
                    .then (response => {
                        this.bans = response.data
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Getting invoices error',
                            text: 'An error has occured during getting error during getting invoices data for selected period.',
                            duration: 5000,
                        });
                        console.log(error)
                    })
            },
            generateCsv() {
                this.$refs['fileFormatModal'].hide()
                this.loadingGenerating = true
                    Axios.get(globalStore.data.restApiUrl + '/reporting/billing/' + this.reportSelected + '/csv')
                        .then(response => {
                            this.loading = false
                            let csvContent = "data:text/csv;charset=utf-8," + response.data;
                            var fileLink = document.createElement('a');
                            fileLink.href = csvContent;
                            fileLink.setAttribute('download', this.reportSelectedType + ' Billing Report.csv');
                            document.body.appendChild(fileLink);
                            fileLink.click();
                            this.reportSelected = null
                            this.reportSelectedType = null
                        }).catch(error => {
                        this.loadingGenerating = false
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Getting Report Error',
                            text: 'Something went wrong during downloading Billing Report - Contact Support',
                            duration: 3000,
                        });
                        console.log(error);
                    });
            },
            generateXlsx() {
                this.$refs['fileFormatModal'].hide()
                this.loadingGenerating = true
                    Axios.get(globalStore.data.restApiUrl + '/reporting/billing/' + this.reportSelected + '/xlsx', {responseType: 'blob'})
                        .then((response) => {
                            this.loadingGenerating = false
                            const fileLink = URL.createObjectURL(new Blob([response.data],
                                {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'}
                                )
                            );
                            const link = document.createElement('a')
                            link.href = fileLink
                            link.setAttribute('download', this.reportSelectedType + ' Billing Report.xlsx')
                            document.body.appendChild(link)
                            link.click()
                            this.reportSelected = null
                            this.reportSelectedType = null
                        }).catch(error => {
                        this.loadingGenerating = false
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Getting Report Error',
                            text: 'Something went wrong during downloading Billing Report - Contact Support',
                            duration: 3000,
                        });
                        console.log(error);
                    });
            },
            showfileFormatPopup() {
                this.$refs['fileFormatModal'].show()
            },
            hidefileFormatPopup() {
                this.$refs['fileFormatModal'].hide()
            },
            switchBookmark(bookmark) {
                if (this.activeBookmark != bookmark) {
                    this.activeBookmark = bookmark
                    if (bookmark == 2) {
                        this.getReportsList(true);
                    }
                }
            },
            getReportsListPagination() {
                Axios.get(`${globalStore.data.restApiUrl}/reporting/billing/page-count?size=${this.sortSettings.size}${this.searchString}`)
                    .then(response => {
                        this.paginationCount = response.data
                    })
            },
            getReportsList(resetPage) {
                this.loadingReports = true
                if (resetPage) {
                    this.sortSettings.page = 1
                    this.getReportsListPagination()
                }
                Axios.get(`${globalStore.data.restApiUrl}/reporting/billing?page=${this.sortSettings.page}&sort=${this.sortSettings.sort}&desc=${this.sortSettings.desc}&size=${this.sortSettings.size}${this.searchString}`)
                    .then(response => {
                        this.loadingReports = false
                        this.reportsList = response.data
                        this.reportsNotReady = []
                        for(let report of this.reportsList) {
                            if (report.completedAt == null) {
                                this.reportsNotReady.push(report.reportId)
                            }
                        }
                        if (this.reportsNotReady.length > 0 && this.timeout == null) {
                            this.checkForReports();
                        }
                    })
                    .catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Getting Report Error',
                            text: 'Something went wrong during downloading Billing Reports - Contact Support',
                            duration: 3000,
                        });
                        console.log(error)
                    })
            },
            downloadReport(id, type) {
                this.reportSelected = id
                this.reportSelectedType = type
                this.$refs['fileFormatModal'].show()
            },
            changeSort(sortId) {
                if (sortId == this.sortSettings.sort) {
                    this.sortSettings.desc = !this.sortSettings.desc
                }
                this.sortSettings.sort = sortId
                this.getReportsList(true)
            },
            setAreaSort(sortId) {
                if (sortId != this.sortSettings.sort) {
                    return 'none'
                } else if (sortId == this.sortSettings.sort && this.sortSettings.desc) {
                    return 'descending'
                } else if (sortId == this.sortSettings.sort && this.sortSettings.desc == false) {
                    return 'ascending'
                }
            },
            searchKeyUp() {
                clearTimeout(this.typingTimer)
                this.typingTimer = setTimeout(() => {
                    this.searchRow()
                }, 500)
            },
            searchKeyDown() {
                clearTimeout(this.typingTimer)
            },
            searchRow: function () {
                this.loadingReports = true;
                if (this.filter.length > 2) {
                    this.searchString = '&search=' + escape(this.filter);
                } else {
                    this.searchString = '';
                }
                this.getReportsList(true)
            },
            clearSearch() {
                this.filter = ''
                this.searchRow()
            },
            paginationControll(ev) {
                this.loadingReports = true;
                this.sortSettings.page = ev;
                this.getReportsList(false);
            },
            checkStatementFile() {
                Axios.get(`${globalStore.data.restApiUrl}/reporting/billing/genesis/uploaded?offset=${this.selectedCycle}`)
                    .then(response => {
                        this.genesisFileUploaded = response.data
                    })
            },
            checkForReports(){
                if (this.$router.currentRoute.name == 'Billing Reports') {
                    this.timeout = setTimeout(() => {
                        if (this.activeBookmark == 2) {
                            this.getReportsList(false)
                            this.timeout = null
                        }
                    }, 5000)
                }
            }
        },
        created() {
            this.getBillingCycles();
            this.checkStatementFile()
        }
    }
</script>

<style src="spinkit/scss/spinkit.scss" lang="scss" />
<style lang="scss">
    .billing-reports {
        position: relative;
        background-color: #fff;
        border: 1px solid #C9CFD4;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;

        .bookmarks {
            display: flex;
            border-bottom: 1px solid #c9cfd4;
            .bookmark {
                padding: 17px 25px;
                text-transform: uppercase;
                font-weight: 700;
                cursor: pointer;
                &.active {
                    border-top-left-radius: 5px;
                    border-top-right-radius: 5px;
                    border-top: 1px solid #c9cfd4;
                    border-left: 1px solid #c9cfd4;
                    border-right: 1px solid #c9cfd4;
                    border-bottom: 1px solid #fff;
                    margin-bottom: -1px;
                    color: #0088ff;
                }
            }
        }

        .bookmark-content {
            padding: 20px;
            &.reports {
                padding: 0;
                .siot-table-search-field {
                    display: flex;
                    justify-content: space-between;
                    img {
                        cursor: pointer;
                    }
                    .light-mode {
                        display: initial;
                    }
                    .dark-mode {
                        display: none;
                    }
                }
                table {
                    thead {
                        th {
                            &:nth-child(2) {
                                max-width: 210px;
                            }
                            &:nth-child(3) {
                                max-width: 180px;
                            }
                            &:nth-child(4) {
                                max-width: 210px;
                            }
                            &:nth-child(5) {
                                max-width: 320px;
                            }
                            &:nth-child(6) {
                                max-width: none !important;
                            }
                            &:nth-child(7) {
                                max-width: 280px;
                            }
                            &:nth-child(8) {
                                max-width: 120px;
                                margin-right: 6px;
                            }
                        }
                    }
                    tbody {
                        td {
                            &:nth-child(2) {
                                max-width: 210px;
                            }
                            &:nth-child(3) {
                                max-width: 180px;
                            }
                            &:nth-child(4) {
                                max-width: 210px;
                            }
                            &:nth-child(5) {
                                max-width: 320px;
                            }
                            &:nth-child(6) {
                                max-width: none !important;
                            }
                            &:nth-child(7) {
                                max-width: 280px;
                            }
                            &:nth-child(8) {
                                max-width: 120px;
                            }
                        }
                    }
                    .download {
                        background-color: #00c4b0;
                        font-weight: 700;
                        color: #ffffff;

                        &:hover {
                            background-color: #009889;
                        }
                    }
                }
                .siot-table-footer {
                    padding: 0 20px 20px;
                }
            }
        }

        .reports-settings-box {
            display: flex;
            flex-wrap: nowrap;
            margin-bottom: 20px;

            .carriers-box,
            .periods-box,
            .bans-box {
                padding: 20px;
                border: 1px solid #C9CFD4;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;

                h3 {
                    margin: 0 0 20px 0;
                    font-size: 15px;
                }
            }
            .genesis-file-box {
                padding: 20px;
                border: 1px solid #C9CFD4;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;

                h3 {
                    margin: 0 0 20px 0;
                    font-size: 15px;
                }

                .genesis-file-upload {
                    display: flex;
                    align-items: center;

                    .upload-genesis-file-input {
                        margin: 0 20px 0 0;
                        font-weight: 700;
                        cursor: pointer;
                        input {
                            display: none;
                        }
                    }
                    .invoice-status {
                        display: flex;
                        align-items: center;
                        .invoice-status-text {
                            font-size: 12px;
                            color: #515B65;
                        }
                        .fa-check {
                            margin-right: 8px;
                            &:before {
                                color: #55CD6C;
                            }
                        }

                        .fa-close {
                            margin-right: 8px;
                            &:before {
                                color: #FC4D4D;
                            }
                        }
                    }
                }
            }

            .carriers-box {
                min-width: 260px;
                margin-right: 20px;
                .carrier-option {
                    margin-bottom: 20px;
                    -webkit-border-radius: 5px;
                    -moz-border-radius: 5px;
                    border-radius: 5px;
                    -webkit-box-shadow: 0px 0px 0px 1px rgba(201,207,212,1);
                    -moz-box-shadow: 0px 0px 0px 1px rgba(201,207,212,1);
                    box-shadow: 0px 0px 0px 1px rgba(201,207,212,1);
                    &.selected {
                        -webkit-box-shadow: 0px 0px 0px 2px rgba(0,136,255,1);
                        -moz-box-shadow: 0px 0px 0px 2px rgba(0,136,255,1);
                        box-shadow: 0px 0px 0px 2px rgba(0,136,255,1);
                    }
                    input {
                        display: none;
                    }
                    label {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding: 12px 0;
                        margin: 0;
                        cursor: pointer;
                        img {
                            height: 25px;
                            width: auto;
                        }
                        .light-mode {
                            display: block;
                        }
                        .dark-mode {
                            display: none;
                        }
                    }
                }
            }
            .periods-box {
                display: flex;
                flex-direction: column;
                min-width: 320px;
                margin-right: 20px;
                .date-box {
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    margin-bottom: 20px;
                    label {
                        margin-bottom: 0;
                    }
                    .error-msg {
                        position: absolute;
                        top: 100%;
                        color: #9f191f;
                        font-size: 12px;
                    }
                }
            }
            .bans-box {
                flex-grow: 1;
                .bans-list {
                    display: flex;
                    flex-wrap: wrap;
                    .ban {
                        display: flex;
                        align-items: center;
                        width: 50%;
                        margin-bottom: 40px;

                        .ban-id {
                            margin-right: 20px;
                            font-size: 14px;
                        }

                        .upload-ban-input {
                            margin: 0 20px 0 0;
                            font-weight: 700;
                            cursor: pointer;
                            input {
                                display: none;
                            }
                        }
                        .invoice-status {
                            display: flex;
                            align-items: center;
                            .invoice-status-text {
                                font-size: 12px;
                                color: #515B65;
                            }
                            .fa-check {
                                margin-right: 8px;
                                &:before {
                                    color: #55CD6C;
                                }
                            }

                            .fa-close {
                                margin-right: 8px;
                                &:before {
                                    color: #FC4D4D;
                                }
                            }
                        }
                    }
                }
            }
        }

        .billing-reports-control {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            .radio-box {
                margin: 6px 20px 6px 0;

                input[type="radio"] {
                    display: none;

                    &:checked + label::after {
                        content: '';
                        display: inline-block;
                        position: absolute;
                        left: 4px;
                        top: 4px;
                        width: 8px;
                        height: 8px;
                        margin-right: 8px;
                        background-color: #2F353A;
                        border-radius: 50%;
                    }
                }

                label {
                    position: relative;
                    display: flex;
                    margin: 0;

                    &::before {
                        content: '';
                        display: inline-block;
                        width: 16px;
                        height: 16px;
                        border: 2px solid #2F353A;
                        border-radius: 50%;
                        margin-right: 8px;
                    }
                }
            }
        }
        .loading {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(255, 255, 255, 0.7);
            .loading-inner {
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                .sk-wave {
                    height: 60px;
                    .sk-rect {
                        width: 3px;
                        background-color: #39c354;
                        border-radius: 4px;
                    }
                }
                .text {
                    font-weight: 700;
                }
            }
        }
    }

    #fileFormatModal___BV_modal_body_ {
        padding-top: 0;
        .file-format-popup {
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: #fff;
            padding: 0 20px 20px;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;

            h3 {
                font-size: 15px;
                margin-top: 8px;
                margin-bottom: 20px;
            }

            .btn {
                width: 100px;
            }

            .btn-primary {
                margin: 0 10px 20px;
            }

            .btn-light {
                margin: 10px 0 0;
            }

            .csv {
                background-color: #00559F;
                border-color: #00559F;
            }
            .xls {
                background-color: #207245;
                border-color: #207245;
            }

            .close-icon {
                position: absolute;
                top: 20px;
                right: 20px;
                cursor: pointer;
            }
        }
    }

    .dark-theme {
        .billing-reports {
            background-color: #3a4149;
            border-color: #1a1c1d;
            color: #fff;

            .bookmarks {
                border-color: #1a1c1d;
                .bookmark {
                    border-color: #1a1c1d;
                    &.active {
                        border-bottom-color: #3a4149;
                    }
                }
            }

            .bookmark-content {
                &.reports {
                    .siot-table-search-field {
                        img {
                            cursor: pointer;
                        }
                        .light-mode {
                            display: none;
                        }
                        .dark-mode {
                            display: initial;
                        }
                    }
                }
            }

            .reports-settings-box {
                .genesis-file-box {
                    border-color: #1a1c1d;
                    .genesis-file-upload {
                        .invoice-status {
                            .invoice-status-text {
                                color: #fff;
                            }
                        }
                    }
                }

                .carriers-box,
                .periods-box,
                .bans-box {
                    border-color: #1a1c1d;
                }

                .carriers-box {
                    .carrier-option {
                        -webkit-box-shadow: 0px 0px 0px 1px #1a1c1d;
                        -moz-box-shadow: 0px 0px 0px 1px #1a1c1d;
                        box-shadow: 0px 0px 0px 1px #1a1c1d;
                        &.selected {
                            -webkit-box-shadow: 0px 0px 0px 2px rgba(0,136,255,1);
                            -moz-box-shadow: 0px 0px 0px 2px rgba(0,136,255,1);
                            box-shadow: 0px 0px 0px 2px rgba(0,136,255,1);
                        }
                        label {
                            .light-mode {
                                display: none;
                            }
                            .dark-mode {
                                display: block;
                            }
                        }
                    }
                }

                .periods-box {
                    select {
                        border-color: #1a1c1d;
                        color: #fff;
                        background: url('data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 4 5\'%3e%3cpath fill=\'%230088ff\' d=\'M2 0L0 2h4zm0 5L0 3h4z\'/%3e%3c/svg%3e') no-repeat right 0.75rem center/8px 10px;
                        background-color: #2f353a;
                    }
                }
            }

            .billing-reports-control {
                .radio-box {
                    input[type="radio"] {
                        &:checked + label::after {
                            background-color: #fff;
                        }
                    }
                    label {
                        &::before {
                            border: 2px solid #fff;
                        }
                    }
                }
            }

            .loading {
                background-color: rgba(0, 0, 0, 0.7);
                .loading-inner {
                    .text {
                        color: #fff;
                        font-weight: 700;
                    }
                }
            }
        }

        #fileFormatModal___BV_modal_content_ {
            background-color: #3a4149;
            color: #EDEEEF;

            button {
                color: #fff;
            }
            .file-format-popup {
                background-color: #3a4149;
                color: #EDEEEF;
            }

            .modal-body {
                button.btn-light {
                    color: #23282c;
                }
            }
        }
    }
</style>
